import { IS_MOCK_MODE } from 'src/constants/featureFlag'
import { SERVER_URL } from 'src/constants/serverUrl'
import { requestPost } from 'src/legacy_modules/server/request'

export const verifyForgotPassword = async (email: string) => {
  if (IS_MOCK_MODE) {
    return {}
  }

  await requestPost<{}>({
    url: `${SERVER_URL}/accounts/verify-forgot-password`,
    params: { email },
  })

  return {}
}
